if (!customElements.get("product-form")) {
  customElements.define(
    "product-form",
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector("form");
        // this.form.querySelector('[name=id]').disabled = false;

        this.form.querySelector(".product-variant-id").disabled = false;

        this.form.addEventListener("submit", this.onSubmitHandler.bind(this));
        this.cart =
          document.querySelector("cart-notification") ||
          document.querySelector("cart-drawer");
        this.submitButton = this.querySelector('[type="submit"]');

        if (document.querySelector("cart-drawer"))
          this.submitButton.setAttribute("aria-haspopup", "dialog");

        this.hideErrors = this.dataset.hideErrors === "true";
      }

      onSubmitHandler(evt) {
        evt.preventDefault();

        // Gift Message Validation
        const occasion = document.querySelector(
          ".select2-container--default .select2-selection--single"
        );
        //const occasionValue = document.getElementById("occasion").value;
        var xmastree = document.getElementById("xmas-tree");
        console.log(xmastree);
        console.log('nmavin');
        if(!xmastree){
         console.log('test');
        const giftMessage = document.getElementById("message");
        const recipientName = document.getElementById("receiver-name");
        const senderName = document.getElementById("sender-name");
        const messageWarning = document.getElementById("message-warning");
        const div1 = document.getElementById("div1");
        if (
          (giftMessage.value.trim() === "" ||
            recipientName.value.trim() === "" ||
            senderName.value.trim() === "") &&
          div1.style.display === "block"
        ) {
          const customBorder = "2px solid #fe9903";
          messageWarning.style.display = "flex";
          //occasionValue === "" && (occasion.style.border = customBorder);
          giftMessage.value.trim() === "" &&
            (giftMessage.style.border = customBorder);
          recipientName.value === "" &&
            (recipientName.style.border = customBorder);
          senderName.value === "" && (senderName.style.border = customBorder);
          return;
        } else {
          // messageWarning.style.display = "none";
          // giftMessage.style.border = "";

          if (this.submitButton.getAttribute("aria-disabled") === "true")
            return;
          //Bundle Id
          const unixTimeInSeconds = Math.floor(Date.now() / 1000);
          let mainBundleId = document.getElementById("main_product_bundle_id");
          let messageBundleId = document.getElementById("message_bundle_id");
          const upSellElements = document.querySelectorAll("#bundle_id");
          upSellElements.forEach((el) => {
            el.value = unixTimeInSeconds;
          });
          mainBundleId.value = unixTimeInSeconds;
          messageBundleId.value = unixTimeInSeconds;

          this.handleErrorMessage();

          this.submitButton.setAttribute("aria-disabled", true);
          this.submitButton.classList.add("loading");
          this.querySelector(".loading__spinner").classList.remove("hidden");

          const config = fetchConfig("javascript");
          config.headers["X-Requested-With"] = "XMLHttpRequest";
          delete config.headers["Content-Type"];

          const formData = new FormData(this.form);
          if (this.cart) {
            formData.append(
              "sections",
              this.cart.getSectionsToRender().map((section) => section.id)
            );
            formData.append("sections_url", window.location.pathname);
            this.cart.setActiveElement(document.activeElement);
          }
          config.body = formData;

          fetch(`${routes.cart_add_url}`, config)
            .then((response) => response.json())
            .then((response) => {
              if (response.status) {
                publish(PUB_SUB_EVENTS.cartError, {
                  source: "product-form",
                  productVariantId: formData.get("id"),
                  errors: response.errors || response.description,
                  message: response.message,
                });
                this.handleErrorMessage(response.description);

                const soldOutMessage =
                  this.submitButton.querySelector(".sold-out-message");
                if (!soldOutMessage) return;
                this.submitButton.setAttribute("aria-disabled", true);
                this.submitButton.querySelector("span").classList.add("hidden");
                soldOutMessage.classList.remove("hidden");
                this.error = true;
                return;
              } else if (!this.cart) {
                // window.location = window.routes.cart_url;
                setTimeout(function () {
                  window.location = window.routes.cart_url;
                }, 2000);
                return;
              }

              if (!this.error)
                publish(PUB_SUB_EVENTS.cartUpdate, {
                  source: "product-form",
                  productVariantId: formData.get("id"),
                  cartData: response,
                });
              this.error = false;
              const quickAddModal = this.closest("quick-add-modal");
              if (quickAddModal) {
                document.body.addEventListener(
                  "modalClosed",
                  () => {
                    setTimeout(() => {
                      this.cart.renderContents(response);
                    });
                  },
                  { once: true }
                );
                quickAddModal.hide(true);
              } else {
                this.cart.renderContents(response);
              }
            })
            .catch((e) => {
              console.error(e);
            })
            .finally(() => {
              this.submitButton.classList.remove("loading");
              if (this.cart && this.cart.classList.contains("is-empty"))
                this.cart.classList.remove("is-empty");
              if (!this.error)
                this.submitButton.removeAttribute("aria-disabled");
              this.querySelector(".loading__spinner").classList.add("hidden");
            });
        }
        }else{
           if (this.submitButton.getAttribute("aria-disabled") === "true")
            return;
          //Bundle Id
          const unixTimeInSeconds = Math.floor(Date.now() / 1000);
          let mainBundleId = document.getElementById("main_product_bundle_id");
          let messageBundleId = document.getElementById("message_bundle_id");
          const upSellElements = document.querySelectorAll("#bundle_id");
          upSellElements.forEach((el) => {
            el.value = unixTimeInSeconds;
          });
          mainBundleId.value = unixTimeInSeconds;
          messageBundleId.value = unixTimeInSeconds;

          this.handleErrorMessage();

          this.submitButton.setAttribute("aria-disabled", true);
          this.submitButton.classList.add("loading");
          this.querySelector(".loading__spinner").classList.remove("hidden");

          const config = fetchConfig("javascript");
          config.headers["X-Requested-With"] = "XMLHttpRequest";
          delete config.headers["Content-Type"];

          const formData = new FormData(this.form);
          if (this.cart) {
            formData.append(
              "sections",
              this.cart.getSectionsToRender().map((section) => section.id)
            );
            formData.append("sections_url", window.location.pathname);
            this.cart.setActiveElement(document.activeElement);
          }
          config.body = formData;

          fetch(`${routes.cart_add_url}`, config)
            .then((response) => response.json())
            .then((response) => {
              if (response.status) {
                publish(PUB_SUB_EVENTS.cartError, {
                  source: "product-form",
                  productVariantId: formData.get("id"),
                  errors: response.errors || response.description,
                  message: response.message,
                });
                this.handleErrorMessage(response.description);

                const soldOutMessage =
                  this.submitButton.querySelector(".sold-out-message");
                if (!soldOutMessage) return;
                this.submitButton.setAttribute("aria-disabled", true);
                this.submitButton.querySelector("span").classList.add("hidden");
                soldOutMessage.classList.remove("hidden");
                this.error = true;
                return;
              } else if (!this.cart) {
                window.location = window.routes.cart_url;
                return;
              }

              if (!this.error)
                publish(PUB_SUB_EVENTS.cartUpdate, {
                  source: "product-form",
                  productVariantId: formData.get("id"),
                  cartData: response,
                });
              this.error = false;
              const quickAddModal = this.closest("quick-add-modal");
              if (quickAddModal) {
                document.body.addEventListener(
                  "modalClosed",
                  () => {
                    setTimeout(() => {
                      this.cart.renderContents(response);
                    });
                  },
                  { once: true }
                );
                quickAddModal.hide(true);
              } else {
                this.cart.renderContents(response);
              }
            })
            .catch((e) => {
              console.error(e);
            })
            .finally(() => {
              this.submitButton.classList.remove("loading");
              if (this.cart && this.cart.classList.contains("is-empty"))
                this.cart.classList.remove("is-empty");
              if (!this.error)
                this.submitButton.removeAttribute("aria-disabled");
              this.querySelector(".loading__spinner").classList.add("hidden");
            });
        }
      
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper ||
          this.querySelector(".product-form__error-message-wrapper");
        if (!this.errorMessageWrapper) return;
        this.errorMessage =
          this.errorMessage ||
          this.errorMessageWrapper.querySelector(
            ".product-form__error-message"
          );

        this.errorMessageWrapper.toggleAttribute("hidden", !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }
      }
    
  );
}
